import React from 'react';
import { Button } from 'src/components/ui/button';
import { clsx } from 'clsx';
import { Link } from 'react-router-dom';

const ArrowIcon = ({ fill }) => {
  return (
    <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 5.5625L6.84562 5.5625L3.70125 8.70688L4.5 9.5L9 5L4.5 0.5L3.70687 1.29313L6.84562 4.4375L0 4.4375V5.5625Z"
        fill={fill}
      />
    </svg>
  );
};

export const ProductCard = ({
  arrowFill = '',
  className,
  link = '',
  image = '',
  buttonText = '',
  onClickHandler = () => {},
}) => {
  return (
    <div className={clsx(className, 'border rounded-sm-5 flex-1 shadow px-[62px] pb-11 pt-[59px]')}>
      <div className="flex flex-col gap-11 items-center">
        <img
          src={image}
          alt={`${buttonText}-img`}
          className="w-[133px] h-[133px] drop-shadow-2xl"
        />
        <Link to={link} className="w-full" onClick={onClickHandler}>
          <Button className="flex gap-1 items-center w-full">
            {buttonText} <ArrowIcon fill={arrowFill} />
          </Button>
        </Link>
      </div>
    </div>
  );
};
